<div data-cy="iq-context-analysis__page" class="context-map-wrapper pt-10">
    <!-- <div class="mb-6 mt-6">
        <h3>Omgevingsanalyse</h3>
    </div> -->
    <div #mapContainer class="map-container"></div>

    <!-- Notification bar -->
    <div class="notification-bar" id="analysis-bar" *ngIf="showPolygonLimitExceededErrorPopup()" [ngStyle]="{ left: toggleRightSidePanel() ? '25%':'50%' }">
        <span class="star-badge"><img src="../../../../../../assets/png/star.png" alt="Star"></span>
        <span [innerHTML]="'contexts.invalid_polygon' | transloco"></span>

        <button data-cy="iq-context-analysis__re-draw-polygon-btn" (click)="reDrawPolygon()" class="mb-0 mr-0">{{'contexts.redraw' | transloco}}</button>
    </div>
    <!-- Notification bar -->
    <div class="notification-bar" id="analysis-bar" *ngIf="loadingSavedAnalysis()" [ngStyle]="{ left: toggleRightSidePanel() ? '25%':'50%' }">
        <span class="star-badge"><img src="../../../../../../assets/png/star.png" alt="Star"></span>
        <span>
            {{'contexts.loading_saved_analysis' | transloco }}
        </span>
        <mat-spinner [diameter]="20"></mat-spinner>
    </div>

    <div class="notification-bar" id="analysis-bar" *ngIf="showNotification() && !loadingSavedAnalysis()" [ngStyle]="{ left: toggleRightSidePanel() ? '25%':'50%' }">
        <span class="star-badge"><img src="../../../../../../assets/png/star.png" alt="Star"></span>
        <span>
            {{ 'context_analysis.ready_to_start' | transloco }}
        </span>
        <button data-cy="iq-context-analysis__on-new-analysis-btn" (click)="onNewAnalysis()" class="mb-0 mr-0 flex align-center gap-5" [class.start-analysis]="isProcessing()" [disabled]="isProcessing()">
            <span>{{ 'context_analysis.start' | transloco }}</span>
            <mat-spinner [diameter]="14" *ngIf="isProcessing()"></mat-spinner>
        </button>
    </div>

    <button data-cy="iq-context-analysis__sidebar-toggle-btn" class="sidebar-toggle-btn" *ngIf="toggleRightSidePanel()" (click)="sidebarCollapsed.set(!sidebarCollapsed())" [ngClass]="{ 'collapsed': sidebarCollapsed() }">
        <i class="uil" [ngClass]="sidebarCollapsed() ? 'uil-angle-left' : 'uil-angle-right'"></i>
    </button>

    <div class="sidebar-panel-wrapper" *ngIf="toggleRightSidePanel()" [ngClass]="{ 'collapsed': sidebarCollapsed() }" (scroll)="onSidebarScroll($event)">
        <app-context-sidebar-panel #contextRightSidebar [totalItems]="totalItems" [ContextanalysisData]="contextAnalysisResponse" [physicalContextData]="physicalContextAnalysisResponse" (onItemCollapse)="onDetailClose()" (onLeaveContext)="onBlurContext()" (onHoverContext)="onHoverContext($event.type, $event.item)" (selectedContextItem)="onItemSelection($event)" (onPanelClose)="onRightPanelClose()" (contextTypeChanged)="onContextTypeChange($event)"></app-context-sidebar-panel>
    </div>

    <!-- Scroll to top button -->
    <button data-cy="iq-context-analysis__scroll-to-top-btn" class="scroll-to-top-btn" *ngIf="showScrollToTop() && (toggleRightSidePanel() || toggleContextDetailPanel()) && !sidebarCollapsed()" (click)="scrollToTop()">
        <i class="uil uil-arrow-up"></i>
    </button>
</div>   
